import { Box, HStack, Stack, Text, View, VStack } from 'native-base';
import React, { memo, useCallback, useMemo } from 'react';
import Functions from '../../../utils/Functions';
import { useIsDateBefore, useSafeParseDate, useSafeParseDateFormat } from '../../../hooks';
const WHAT_HAPPENS_NEXT = `What happens next?`;
const WHAT_HAPPENS_POINT_ONE = `Expect your monthly mortgage payment to increase (see table below)`;
const WHAT_HAPPENS_POINT_TWO = `Choose a payment option below and pay the shortage amount in one lump sum or spread out the `;
const OVER_THE_NEXT = timeFrame => ` over the next ` + timeFrame + ` months.`;
const WHAT_HAPPENS_POINT_THREE = `If your payment is set up to automatically withdraw each month, that will continue, and any change to your payment will also be automatically updated. If you use a third party to make your payments, please notify them and update your new monthly payment amount.`;
const WHAT_HAPPENS_POINT_FOUR = `Paying an escrow shortage in full may still result in a monthly payment increase due to higher taxes and/or insurance payments.`;
const IF_DO_NOT = `If you do not respond `;
const REST_OF_TEXT = timeFrame => `, the amount will be automatically spread over next ` + timeFrame + ` months for you.`;
const SURPLUS_POINT_ONE = `You will receive a check for this amount in the mail along with your escrow analysis statement.`;
const SURPLUS_POINT_TWO = `Please begin making your new lower payment on `;
const SURPLUS_SEE_BELOW = ` (see table below).`;
const SURPLUS_POINT_THREE = `If your payment is set up to automatically withdraw each month, that will continue, and any change to your payment will also be automatically updated. If you use a third party to make your payments, please notify them and update your new monthly payment amount.`;
const WhatNext = _ref => {
  let {
    amount,
    date,
    type,
    timeFrame
  } = _ref;
  const shouldShow = useIsDateBefore(date);
  const effectiveDate = useSafeParseDateFormat(date);
  const effectiveDateType = useSafeParseDate(date);
  const points = useMemo(() => {
    if (type === 'shortage') {
      return [WHAT_HAPPENS_POINT_ONE, `${WHAT_HAPPENS_POINT_TWO}${Functions.toUSD(amount)}${OVER_THE_NEXT(String(timeFrame ?? ''))}`, WHAT_HAPPENS_POINT_THREE, WHAT_HAPPENS_POINT_FOUR];
    } else {
      return [SURPLUS_POINT_ONE, `${SURPLUS_POINT_TWO}${effectiveDate}${SURPLUS_SEE_BELOW}`, SURPLUS_POINT_THREE];
    }
  }, [effectiveDate, type, amount]);
  const RenderNumberedPoints = useCallback((point, index) => {
    return /*#__PURE__*/React.createElement(View, {
      key: index
    }, /*#__PURE__*/React.createElement(HStack, {
      key: `point-${index}`,
      space: 1
    }, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Text, {
      w: "4",
      fontSize: {
        base: 'sm',
        md: 'lg',
        lg: 'lg'
      },
      fontWeight: 300,
      color: '#222A34',
      accessibilityLabel: `${index + 1}`,
      accessibilityRole: "text"
    }, index + 1, ".")), /*#__PURE__*/React.createElement(Text, {
      flex: 1,
      fontSize: {
        base: 'sm',
        md: 'lg',
        lg: 'lg'
      },
      fontWeight: 300,
      color: '#222A34',
      accessibilityLabel: point,
      accessibilityRole: "text"
    }, point)));
  }, []);
  return !shouldShow ? null : /*#__PURE__*/React.createElement(Box, {
    mt: "4",
    accessibilityLabel: WHAT_HAPPENS_NEXT,
    accessibilityRole: "text"
  }, /*#__PURE__*/React.createElement(Text, {
    bold: true,
    fontSize: {
      base: 'sm',
      md: 'lg',
      lg: 'lg'
    }
  }, WHAT_HAPPENS_NEXT), /*#__PURE__*/React.createElement(Stack, {
    mx: {
      base: '5',
      md: '5',
      lg: '5'
    },
    my: 2
  }, type === 'shortage' ? /*#__PURE__*/React.createElement(VStack, {
    pl: "2"
  }, points.map(RenderNumberedPoints)) : /*#__PURE__*/React.createElement(VStack, {
    pl: "2"
  }, /*#__PURE__*/React.createElement(HStack, {
    key: `point-1`,
    space: 2
  }, /*#__PURE__*/React.createElement(Text, {
    fontSize: {
      base: 'sm',
      md: 'lg',
      lg: 'lg'
    },
    fontWeight: 300,
    color: '#222A34',
    accessibilityLabel: `1`,
    accessibilityRole: "text"
  }, "1."), /*#__PURE__*/React.createElement(Text, {
    fontSize: {
      base: 'sm',
      md: 'lg',
      lg: 'lg'
    },
    flex: 1,
    fontWeight: 300,
    color: '#222A34',
    accessibilityLabel: SURPLUS_POINT_ONE,
    accessibilityRole: "text"
  }, SURPLUS_POINT_ONE)), /*#__PURE__*/React.createElement(HStack, {
    key: `point-2`,
    space: 2
  }, /*#__PURE__*/React.createElement(Text, {
    fontSize: {
      base: 'sm',
      md: 'lg',
      lg: 'lg'
    },
    fontWeight: 300,
    color: '#222A34',
    accessibilityLabel: `2`,
    accessibilityRole: "text"
  }, "2."), /*#__PURE__*/React.createElement(Text, {
    fontSize: {
      base: 'sm',
      md: 'lg',
      lg: 'lg'
    },
    flex: 1,
    fontWeight: 300,
    color: '#222A34',
    accessibilityLabel: `${SURPLUS_POINT_TWO}${effectiveDate}${SURPLUS_SEE_BELOW}`,
    accessibilityRole: "text"
  }, SURPLUS_POINT_TWO, /*#__PURE__*/React.createElement(Text, {
    bold: true
  }, effectiveDate), SURPLUS_SEE_BELOW)), /*#__PURE__*/React.createElement(HStack, {
    key: `point-2`,
    space: 2
  }, /*#__PURE__*/React.createElement(Text, {
    fontSize: {
      base: 'sm',
      md: 'lg',
      lg: 'lg'
    },
    fontWeight: 300,
    color: '#222A34',
    accessibilityLabel: `3`,
    accessibilityRole: "text"
  }, "3."), /*#__PURE__*/React.createElement(Text, {
    fontSize: {
      base: 'sm',
      md: 'lg',
      lg: 'lg'
    },
    flex: 1,
    fontWeight: 300,
    color: '#222A34',
    accessibilityLabel: SURPLUS_POINT_THREE,
    accessibilityRole: "text"
  }, SURPLUS_POINT_THREE)))), type === 'surplus' ? null : /*#__PURE__*/React.createElement(Text, {
    fontSize: {
      base: 'sm',
      md: 'lg',
      lg: 'lg'
    },
    lineBreakMode: "head",
    fontWeight: 300,
    color: '#222A34',
    accessibilityLabel: `${IF_DO_NOT}before${effectiveDateType}${REST_OF_TEXT}`,
    accessibilityRole: "text"
  }, IF_DO_NOT, /*#__PURE__*/React.createElement(Text, {
    bold: true
  }, "before ", effectiveDateType), REST_OF_TEXT(String(timeFrame ?? ''))));
};
export default /*#__PURE__*/memo(WhatNext);
//# sourceMappingURL=index.js.map